import { Fragment } from 'react';
import {
  Grid,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  Table,
  TableHead,
} from '@mui/material';
import MuiRadioGroup from './components/MuiRadioGroup';

import { IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues, IFormWatch {
  disabled?: boolean;
}

const KOOSContents = (props: Props) => {
  const { disabled, getValues, setValue } = props;

  return (
    <Fragment>
      <Typography sx={{ fontSize: '14px', margin: '40px 0 -10px 25px' }}>
        Hướng dẫn: Cuộc khảo sát này yêu cầu quan điểm của bạn về đầu gối của
        bạn. Thông tin này sẽ giúp chúng tôi theo dõi xem bạn cảm thấy thế nào
        về đầu gối của mình và khả năng thực
        <br />
        hiện các hoạt động thường ngày của mình tốt như thế nào. Trả lời mọi câu
        hỏi bằng cách bấm vào ô thích hợp, mỗi câu hỏi chỉ chọn một đáp án. Nếu
        bạn không biết phải trả lời câu hỏi như
        <br />
        thế nào, xin vui lòng đưa ra câu trả lời tốt nhất có thể.
      </Typography>
      <SectionTitle title="Triệu chứng" />
      <Grid item xs={12}>
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: '500',
            width: '500px',
            marginLeft: '15px',
          }}
          maxHeight={20}
          whiteSpace={'nowrap'}
        >
          Hãy trả lời những câu hỏi sau dựa vào các triệu chứng của khớp gối
          mình trong tuần vừa qua.
        </Typography>
        <Table size="small">
          <TableBody>
            <TableRow>
              <TableCell></TableCell>
              <TableCell sx={{ textAlign: 'right' }}></TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: '400',
                  }}
                  maxHeight={20}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  Đầu gối bạn có bị sưng không?
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'right' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  i18nNullKey="ETC"
                  i18nKey="KOOS.SYMPTOMS"
                  values={[1, 2, 3, 4, 5]}
                  defaultValue={getValues('spt01')}
                  onChange={v => setValue('spt01', v)}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: '400',
                  }}
                  maxHeight={50}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  Bạn có cảm thấy đau nhói, nghe tiếng lụp cụp hay bất kỳ loại
                  <br />
                  âm thanh nào khác khi đầu gối của bạn cử động không?
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'right' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  i18nNullKey="ETC"
                  i18nKey="KOOS.SYMPTOMS"
                  values={[1, 2, 3, 4, 5]}
                  defaultValue={getValues('spt02')}
                  onChange={v => setValue('spt02', v)}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: '400',
                    width: '500px',
                  }}
                  maxHeight={20}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  Đầu gối của bạn có bị kẹt hoặc bị dừng đột ngột khi di chuyển
                  <br />
                  không?
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'right' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  i18nNullKey="ETC"
                  i18nKey="KOOS.SYMPTOMS"
                  values={[1, 2, 3, 4, 5]}
                  defaultValue={getValues('spt03')}
                  onChange={v => setValue('spt03', v)}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: '400',
                    width: '500px',
                  }}
                  maxHeight={20}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  Bạn có thể duỗi thẳng đầu gối hoàn toàn không?
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'right' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  i18nNullKey="ETC"
                  i18nKey="KOOS.SYMPTOMS"
                  values={[1, 2, 3, 4, 5]}
                  defaultValue={getValues('spt04')}
                  onChange={v => setValue('spt04', v)}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: '400',
                    width: '500px',
                  }}
                  maxHeight={20}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  Bạn có thể gập đầu gối hoàn toàn không?
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'right' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  i18nNullKey="ETC"
                  i18nKey="KOOS.SYMPTOMS"
                  values={[1, 2, 3, 4, 5]}
                  defaultValue={getValues('spt05')}
                  onChange={v => setValue('spt05', v)}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Grid>

      <SectionTitle title="Cứng khớp" />
      <Grid item xs={12}>
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: '500',
            width: '500px',
            marginLeft: '15px',
          }}
          maxHeight={35}
          whiteSpace={'nowrap'}
        >
          Những câu hỏi sau đây liên quan đến mức độ cứng ở khớp gối mà bạn trải
          qua trong tuần vừa qua.
          <br />
          Cứng khớp là cảm giác bị giới hạn hoặc chậm lại trong khi bạn vận động
          đầu gối của mình
        </Typography>
        <Table size="small">
          <TableBody>
            <TableRow>
              <TableCell></TableCell>
              <TableCell sx={{ textAlign: 'right' }}></TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: '400',
                    width: '500px',
                  }}
                  maxHeight={50}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  Khớp gối của bạn bị cứng ở mức độ nào vào buổi sáng ngay khi
                  <br />
                  thức dậy?
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'right' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  i18nNullKey="ETC"
                  i18nKey="KOOS.STIFFNESS"
                  values={[1, 2, 3, 4, 5]}
                  defaultValue={getValues('stf01')}
                  onChange={v => setValue('stf01', v)}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: '400',
                    width: '500px',
                  }}
                  maxHeight={50}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  Khớp gối của bạn bị cứng ở mức độ nào sau khi ngồi, nằm hoặc
                  <br />
                  nghỉ ngơi vào cuối ngày?
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'right' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  i18nNullKey="ETC"
                  i18nKey="KOOS.STIFFNESS"
                  values={[1, 2, 3, 4, 5]}
                  defaultValue={getValues('stf02')}
                  onChange={v => setValue('stf02', v)}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Grid>
    </Fragment>
  );
};

export default KOOSContents;
